import { ExportContext, ExportMutations } from "./types";
import { ExportFilters } from "@/models/export/filters";


export const addExportFilters = (
  context: ExportContext,
  value: ExportFilters
) => {
  context.commit(ExportMutations.SetExportFilters, value);
};

